import type { InteractionMetrics } from "./types";

const interactions: Map<string, InteractionMetrics> = new Map();

export default interactions;
